import { Reducer } from 'react';
import { ISnackbarInput } from '../Components/CustomUIElements/StyledSnackbar';
import { IAttachment, IVideoInterview } from '../Application/types';

export const InitialExternalViewState: ExternalViewState = {
  snackbar: {
    message: '',
    state: 'success'
  },
  previewAttachment: false,
  selectedAttachment: null
};

export interface ExternalViewState {
  snackbar: ISnackbarInput;
  previewAttachment: boolean;
  selectedAttachment: IAttachment | IVideoInterview | null;
}

export type ExternalViewAction =
  | {
      type: 'SET_SNACKBAR';
      payload: ISnackbarInput;
    }
  | {
      type: 'SET_PREVIEW_ATTACHMENT';
      payload: boolean;
    }
  | {
      type: 'SET_SELECTED_ATTACHMENT';
      payload: IAttachment | IVideoInterview | null;
    };

export const ExternalViewReducer: Reducer<ExternalViewState, ExternalViewAction> = (
  state: ExternalViewState,
  action: ExternalViewAction
) => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return { ...state, snackbar: action.payload };
    case 'SET_PREVIEW_ATTACHMENT':
      return { ...state, previewAttachment: action.payload };
    case 'SET_SELECTED_ATTACHMENT':
      return { ...state, selectedAttachment: action.payload };
    default:
      return state;
  }
};
